import {
    type TextStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    CommandInputDynamicStyleType
} from "../../type";
import {
    getInputTextStyle
} from "../../../../helpers/theme/input";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    icon: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    crumbs: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0,
        minWidth: 0
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "stretch",
        flexShrink: 0
    }
});

export const useStyles = ({
    isLeadingButton,
    currentSize,
    pointerType,
    typography,
    borders,
    variant,
    colors,
    spaces
}: CommandInputDynamicStyleType) => {
    const iconPadding = spaces.spacingXs + spaces.spacingSm;

    const styles = {
        container: {
            paddingStart: isLeadingButton ? spaces.spacingSm : variant === "inline" ? currentSize.paddingHorizontal : iconPadding,
            borderBottomColor: colors.content.border.subtle,
            paddingEnd: currentSize.paddingHorizontal,
            borderBottomWidth: borders.separator,
            marginHorizontal: -spaces.spacingXs,
            marginBottom: spaces.spacingXs,
            marginTop: -spaces.spacingXs,
            height: currentSize.height,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        input: {
            ...getInputTextStyle({
                textStyle: typography[currentSize.variant],
                pointerType,
                typography
            }),
            color: colors.content.text.high
        } as Mutable<TextStyle>,
        action: {
            marginEnd: -currentSize.actionOffset
        } as Mutable<ViewStyle>,
        icon: {
            height: currentSize.iconSize,
            width: currentSize.iconSize
        } as Mutable<ViewStyle>,
        crumbs: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    delete styles.input.lineHeight;

    return styles;
};
export default stylesheet;
